import Action from './action';

const initialState = {
    contactEmail: '',
    errorText: '',
    isNeedContactEmail: true,
};

export default (state = initialState, action: {type: string, payload: string}) => {
    switch (action.type) {
        case Action.UPDATE_CONTACT_EMAIL: {
            return {
                ...state,
                contactEmail: action.payload
            }
        }
        case Action.UPDATE_CONTACT_EMAIL_ERROR_TEXT: {
            try {
                action.payload && (window as any).mailStats.show('contact_email_error', { errorText: action.payload })
            } catch(e) {}
            return {
                ...state,
                errorText: action.payload
            }
        }
        case Action.UPDATE_CONTACT_EMAIL_NEED: {
            return {
                ...state,
                isNeedContactEmail: action.payload
            }
        }
        default: return state;
    }
}
